import { useFormFlowContext } from "@particles/FormFlow/FormFlow.context"

import Button from "@atoms/Button/Button"

import { FormFlowNextButtonProps } from "./FormFlowNextButton.types"

function FormFlowNextButton(props: FormFlowNextButtonProps) {
    const { children = "Next", variant = "solid", size = "md", noDebounce = true, ...rest } = props
    const { goToNextStep } = useFormFlowContext()

    return (
        <Button
            {...rest}
            type="button"
            variant={variant}
            size={size}
            onClick={() => void goToNextStep()}
            noDebounce={noDebounce}
        >
            {children}
        </Button>
    )
}

export default FormFlowNextButton
